<!--Recover Password-->
<div class="forgot-password d-flex align-items-center justify-content-between">
  <div class="login-block mx-auto text-center position-relative shadow-box">
    <div class="d-flex justify-content-center mb-1">
      <img class="newLogo" src="/assets/img/New Logo - Transperent.png" width="80" height="80" alt="" />
    </div>
    <strong class="text-center font-2x responsive-text mb-2" style="color: #026d64">
      Welcome to Nisargopchar Ashram
    </strong>
    <div class="mb-2">
      <h2 class="text-center text-dark text-capitalize font-2x fontsizeandfamilyCalibri">Recover Password</h2>
      <p>{{"Enter your registered email to receive OTP" |translate}}</p>
    </div>

    <form #form="ngForm" class="login-form" action="javascript:void(0)" method="post">
      <div class="d-flex justify-content-center align-items-center">
        <div class="col-lg-1"></div>
        <div class="input-group">
          <input type="email" name="email" class="form-control" [(ngModel)]="UserEmail" placeholder="Your email"
            required [disabled]="isOTPVerify" />
          <div class="input-group-append">
            <button type="button" (click)="forgetPassword()" class="btn btn-block btn-square text-white"
              style="background-color:#0d9488; line-height:1;">
              {{ 'Send OTP' | translate }}
            </button>
          </div>
        </div>
        <div class="col-lg-1"></div>
      </div>
      <div [ngClass]="isInProgress ? 'blink_me mt-2' : 'd-none'">
        <label>Sending OTP ...</label>
      </div>
      <p class="resend-text" *ngIf="isOTPSend && !isOTPVerify"> <!--Resend OTP-->
        Didn't receive the OTP?
        <button (click)="resendOtp()" class="btn btn-link text-primary resend-link"
          [disabled]="isResendDisabled || isResendUsed">
          Resend OTP <span *ngIf="isResendDisabled">({{ countdown }})</span>
        </button>
      </p>

      <div class="otp-inputs" *ngIf="!isOTPVerify"> <!--OTP-->
        <input *ngFor="let digit of otp; let i = index" type="text" maxlength="1" [value]="otp[i]"
          (input)="onInput($event, i)" (keypress)="validateService.numberOnly($event)" (keydown)="onKeyDown($event, i)"
          #otpInput [disabled]="!isOTPSend && !isOTPVerify" />
      </div>
      <div class="d-flex justify-content-center align-items-center mt-2" *ngIf="isOTPVerify">
        <div class="col-lg-1"></div>
        <div class="input-group mb-2"> <!--New Password/ USer ID-->
          <input type="text" class="form-control" placeholder="New {{type}}" [type]="hide1 ? 'password' : 'text'"
            id="Password1" name="Password1" maxlength="10" minlength="4" [(ngModel)]="NewPassword" required>
          <div class="input-group-append">
            <span class="input-group-text">
              <i id='icons' class="fa " [ngClass]="hide1 ? 'fa-eye' : 'fa-eye-slash'" (click)="hide1 = !hide1"></i>
            </span>
          </div>
        </div>
        <div class="col-lg-1"></div>
      </div>
      <div class="d-flex justify-content-center align-items-center" *ngIf="isOTPVerify">
        <div class="col-lg-1"></div>
        <div class="input-group"> <!--Confirm Password/User ID-->
          <input type="text" class="form-control" placeholder="Confirm {{type}}" [type]="hide2 ? 'password' : 'text'"
            id="Password2" name="Password2" maxlength="10" minlength="4" [(ngModel)]="ConfirmPassword" required>
          <div class="input-group-append">
            <span class="input-group-text">
              <i id='icons' class="fa " [ngClass]="hide2 ? 'fa-eye' : 'fa-eye-slash'" (click)="hide2 = !hide2"></i>
            </span>
          </div>
        </div>
        <div class="col-lg-1"></div>
      </div>

      <div class="row mt-2">
        <div class="col-lg-2"></div>
        <div class="col col-lg"> <!--Send OTP button-->
          <button type="button" (click)="isOTPVerify ? SaveForgotPassword() : verifyOtp()"
            class="btn btn-block btn-square btn-lg text-white" style="background:'#0d9488'"
            [disabled]="!isOTPSend && !isOTPVerify">
            Submit</button>
        </div>
        <div class="col-lg-2"></div>
      </div>

      <!-- [ngClass]="item.IsVisitDone == 'IN' ? 'blink_me ml-2' : 'd-none'" -->
      <!-- <div [ngClass]="isInProgress ? 'blink_me mt-2' : 'd-none'">
        <label>Sending OTP ...</label>
      </div> -->
      <div class="text-center mt-2" style="font-family: Calibri">
        If you are new user ?
        <a routerLink="/session/booking-login/booking-login-register" class="text-primary font-weight-bold">Sign Up</a> here
      </div>
      <!-- Home -->
      <div class="text-center mt-2" style="font-family: Calibri">
        Return to
        <!-- routerLink="/session/home" -->
        <a routerLink="/session/home" class="text-primary font-weight-bold">Home</a>
      </div>
    </form>
  </div>

  <!--Enter OTP-->
  <div class="Verify-block mx-auto text-center position-relative shadow-box d-none" *ngIf="isOTPSend && !isOTPVerify">
    <div class="otp-container">
      <h2>Enter OTP</h2>
      <p class="otp-subtext">We've sent a 4-digit OTP to your email. Please enter it below.</p>

      <div class="otp-inputs"> <!--OTP-->
        <input *ngFor="let digit of otp; let i = index" type="text" maxlength="1" [value]="otp[i]"
          (input)="onInput($event, i)" (keypress)="validateService.numberOnly($event)" (keydown)="onKeyDown($event, i)"
          #otpInput />
      </div>
      <button (click)="verifyOtp()" class="Verifybutton btn-verify">Verify OTP</button> <!--Verify OTP-->
      <p *ngIf="errorMessage" class="error">{{ errorMessage }}</p>
      <p class="resend-text"> <!--Resend OTP-->
        Didn't receive the OTP?
        <!-- <a *ngIf="!isResendDisabled" (click)="resendOtp()" class="text-primary resend-link">Resend OTP</a>
        <button *ngIf="isResendDisabled" (click)="resendOtp()" class="btn btn-link text-primary resend-link" disabled>
          Resend OTP <span>({{ countdown }})</span>
        </button> -->

        <button (click)="resendOtp()" class="btn btn-link text-primary resend-link"
          [disabled]="isResendDisabled || isResendUsed">
          Resend OTP <span *ngIf="isResendDisabled">({{ countdown }})</span>
        </button>
      </p>
    </div>
  </div>

  <!--Reset password/userid-->
  <div class="Verify-block mx-auto text-center position-relative shadow-box d-none" *ngIf="isOTPSend && isOTPVerify">
    <div class="d-block d-sm-flex justify-content-center align-items-center mt-5">
      <div class="col-lg mx-auto">
        <h2>Reset {{type}}</h2>
        <form #f="ngForm" novalidate>
          <div class="input-group mb-3"> <!--User email id-->
            <input type="text" class="form-control" placeholder="Username" disabled [(value)]="UserEmail">
          </div>
          <div class="input-group mb-3"> <!--New Password/ USer ID-->
            <input type="text" class="form-control" placeholder="New {{type}}" [type]="hide1 ? 'password' : 'text'"
              id="Password1" name="Password1" maxlength="10" minlength="4" [(ngModel)]="NewPassword" required>
            <div class="input-group-append">
              <span class="input-group-text">
                <i id='icons' class="fa " [ngClass]="hide1 ? 'fa-eye' : 'fa-eye-slash'" (click)="hide1 = !hide1"></i>
              </span>
            </div>
          </div>
          <div class="input-group mb-3"> <!--Confirm Password/User ID-->
            <input type="text" class="form-control" placeholder="Confirm {{type}}" [type]="hide2 ? 'password' : 'text'"
              id="Password2" name="Password2" maxlength="10" minlength="4" [(ngModel)]="ConfirmPassword" required>
            <div class="input-group-append">
              <span class="input-group-text">
                <i id='icons' class="fa " [ngClass]="hide2 ? 'fa-eye' : 'fa-eye-slash'" (click)="hide2 = !hide2"></i>
              </span>
            </div>
          </div>
          <div class="d-flex"> <!--Clear button-->
            <button type="button" class="btn btn-md bg-primary mr-3" (click)="Clear()">
              <i class="fa fa-eraser mr-1" aria-hidden="true"></i>
              Clear
            </button> <!--Save button-->
            <button type="button" id="saveChangePassword" class="btn btn-md bg-primary" (click)="SaveForgotPassword()"
              [disabled]="!f.valid">
              <i class="fa fa-save mr-1" aria-hidden="true"></i>
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>